import { useEffect } from 'react'
import dynamic from 'next/dynamic'
import { BogoBanner } from '@mc/bogo'
import { PAGE_SOURCES, PromoExplainerModal } from '@mc/promos'
import { StickyFooter } from 'components/StickyFooter'
import { trackProductListViewed } from 'libs/events'
import { Meta } from '../components'
import type { CategoryPageProps } from '../pageProps'
import { PageDataProvider, Hero, CategoryNavCarousel } from './components'

const BelowTheFold = dynamic(
  () => import('./components/BelowTheFold').then((m) => m.BelowTheFold),
  { ssr: false },
)

export const CategoryPage = ({
  slug,
  category,
  categories,
  subcategories,
  categorySavedDynamicHero,
  dynamicSubcategoryNames,
}: CategoryPageProps) => {
  useEffect(() => {
    trackProductListViewed(category?.id)
  }, [category])

  if (!subcategories) {
    return null
  }

  return (
    <PageDataProvider
      value={{
        categories,
        slug,
        subcategories,
        category,
        categorySavedDynamicHero,
        dynamicSubcategoryNames,
      }}
    >
      <Meta />
      <BogoBanner className='mc-mb-2' />
      <PromoExplainerModal pageSource={PAGE_SOURCES.CATEGORY_PAGE} />
      <div className='container'>
        <div className='mc-mb-6'>
          <CategoryNavCarousel />
        </div>
        <Hero />
      </div>
      <BelowTheFold />
      <StickyFooter />
    </PageDataProvider>
  )
}
